import { createCustomerApiClient } from "../lib/apiClient";

const api = createCustomerApiClient();

export const fetchCustomers = () => api.get("/organisations");

export const fetchCustomer = ({ queryKey }) => {
  const customerId = queryKey[1];
  return api.get(`/organisations/${customerId}`);
};

export const postCustomer = (organisation) =>
  api.post("/organisations", organisation);

export const putCustomer = ({ customerId, ...customer }) =>
  api.put(`/organisations/${customerId}`, customer);

export const deleteCustomer = (customerId) => {
  if (customerId === undefined) {
    return undefined;
  }
  return api.delete(`/organisations/${customerId}`);
};
